import React from "react";
import { Route, Routes } from "react-router-dom";
import NotFound from "../utils/NotFound";
import CommissaryProducts from "../components/commissary/products";
import Commissaryconfigs from "../components/commissary/configs";
import CommissaryMerchants from "../components/commissary/merchants";
import CommissaryInventory from "../components/commissary/inventory";
import CommissaryUnits from "../components/commissary/units";
import CommissaryDelivery from "../components/commissary/delivery";
import RawProcess from "../components/commissary/process";
import CommissaryCategory from "../components/commissary/category";
import MerchantDetails from "../components/commissary/merchants/MerchantDetails";
import Poster from "../components/welcome/Poster";
import CommissaryEmployee from "../components/commissary/employee";

const CommissaryRoute = () => {
  return (
    <>
      <React.Fragment>
        <Routes>
          <Route hidden path="/" element={<CommissaryProducts />} />
          <Route hidden path="/merchants" element={<CommissaryMerchants />} />
          <Route hidden path="/configs" element={<Commissaryconfigs />} />
          <Route hidden path="/invetory" element={<CommissaryInventory />} />
          <Route hidden path="/production" element={<RawProcess />} />
          <Route hidden path="/delivery" element={<CommissaryDelivery />} />
          <Route hidden path="/units" element={<CommissaryUnits />} />
          <Route hidden path="/category" element={<CommissaryCategory />} />
          <Route hidden path="/employee" element={<CommissaryEmployee />} />

          <Route
            hidden
            path="/merchants/:merchant_id/:merchant_user_id"
            element={<MerchantDetails />}
          />
          <Route hidden path="/poster-1" element={<Poster />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </React.Fragment>
    </>
  );
};

export default CommissaryRoute;
